import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";
import { PRESS, RECOGNITION } from "@/data/content";

export default function Press() {
  return (
    <div data-testid="press-page">
      <PageHeader
        kicker="Press"
        title='Featured <span class="text-warm-600">by.</span>'
        intro="Coverage from The New York Times, Net Influencer, Anthropologie, Forbes, Business Insider, and Variety — alongside industry recognition from the NYT Best Sellers list, the Streamy and Shorty Awards."
      />

      <section className="mx-auto max-w-[1500px] px-6 md:px-10 lg:px-14 pb-32">
        <ul className="divide-y divide-line border-t border-line">
          {PRESS.map((p, i) => (
            <Reveal as="li" key={p.url} delay={i * 60}>
              <a
                href={p.url}
                target="_blank"
                rel="noreferrer"
                data-testid={`press-row-${p.outlet.toLowerCase().replace(/\s+/g, "-")}`}
                className="group grid grid-cols-12 gap-6 items-start py-10 md:py-14 hover:bg-mute px-2 transition-colors"
              >
                <div className="col-span-3 md:col-span-2 eyebrow pt-2">{p.year}</div>
                <div className="col-span-9 md:col-span-3 eyebrow pt-2">{p.outlet}</div>
                <div className="col-span-12 md:col-span-6">
                  <div className="display text-ink group-hover:text-warm-600 transition-colors" style={{ fontSize: "clamp(22px, 2.6vw, 40px)" }}>
                    {p.title}
                  </div>
                  {p.pull && (
                    <p className="mt-3 text-warm-600 leading-relaxed text-base max-w-2xl">{p.pull}</p>
                  )}
                </div>
                <div className="col-span-12 md:col-span-1 md:text-right">
                  <ArrowUpRight className="ml-auto text-warm-500 group-hover:text-ink group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" size={22} />
                </div>
              </a>
            </Reveal>
          ))}
        </ul>

        <div className="mt-24">
          <div className="eyebrow mb-8">Recognition</div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-line border border-line">
            {RECOGNITION.map((r) => (
              <div key={r} className="bg-paper py-12 px-6 flex items-center justify-center">
                <span className="display text-ink text-xl md:text-2xl">{r}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
